// This is for all the forms on the website

var inputFieldHandlers;
inputFieldHandlers = {
    shiftLabelUp: function () {
        jQuery(this)
            .parent()
            .find('label')
            .addClass("small");
    },

    shiftLabelDownIfEmpty: function () {
        if (jQuery(this)
            .val() !== "") {
            return;
        }
        jQuery(this)
            .parent()
            .find('label')
            .removeClass("small");
    },

    determineValidityState: function () {
        var input = jQuery(this);
        if (input.val() === "") {
            input.addClass("invalid")
                .removeClass("valid")
                .parent()
                .find('p')
                .addClass("visible"); //TODO css
        }
        else {
            input.addClass("valid")
                .removeClass("invalid")
                .parent()
                .find('p')
                .removeClass("visible"); //TODO css
        }
        if (input[0].type === 'checkbox') {
            if (input[0].checked) {
                input.removeClass("invalid");
                input.closest('.checkbox')
                    .find('p.error')
                    .removeClass('visible');
            }
        }

    },

    validateEmail: (emailField) => {
        const $field = jQuery(emailField);
        const str = $field.val()
            .trim()
            .toLowerCase();
        const validEmailRegex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        $field
            .removeClass("invalid")
            .addClass("valid")
            .parent()
            .find('p')
            .removeClass("visible");
        // Test for blacklist email
        const shouldApplyBlacklist = !$field.hasClass('no-blacklist');
        if (shouldApplyBlacklist && window.emailBlacklist && Array.isArray(window.emailBlacklist) && window.emailBlacklist.filter((blacklistedEmail) => str.includes(`@${blacklistedEmail}`)).length > 0) {
            $field
                .removeClass("valid")
                .addClass("invalid")
                .parent()
                .find('p.blacklist')
                .addClass("visible");
        }
        else if (!validEmailRegex.test(str)) {
            $field
                .removeClass("valid")
                .addClass("invalid")
                .parent()
                .find('p:not(.blacklist)')
                .addClass("visible");
        }
    },

    validateWebsite: (urlField) => {
        if (!urlField.checkValidity()) {
            return jQuery(urlField)
                .removeClass("valid")
                .addClass("invalid")
                .parent()
                .find('p')
                .addClass("visible");
        }
        jQuery(urlField)
            .removeClass("invalid")
            .addClass("valid")
            .parent()
            .find('p')
            .removeClass("visible");
    },

    isValid: (form) => {
        const allInputFields = jQuery('input, select', form)
            .toArray();
        let isValid = true;
        allInputFields.forEach((input) => {
            if (input.classList.contains('lazy-validate') && input.type === 'email') {
                inputFieldHandlers.validateEmail(input);
            }
            if (input.type === 'url') {
                inputFieldHandlers.validateWebsite(input);
            }
        });
        //If any field is invalid, disable
        allInputFields.forEach((field) => {
            if (field.classList.contains('invalid')) {
                isValid = false;
            }
        });
        //If any required field is not valid, disable
        const requiredFields = jQuery('input.required, select.required', form)
            .toArray();
        requiredFields.forEach((field) => {
            if (field.classList.contains('valid') !== true && !jQuery(field)
                .parent('.input-field, .select-field')
                .hasClass('hidden')) {
                isValid = false;
            }
        });

        return isValid;
    },

    invalidateEmptyFields: (form) => {
        //Get all required fields
        const requiredFields = jQuery('input.required, select.required, textarea.required, checkbox.required', form)
            .toArray();
        //forEach field if it is empty add class invalid
        requiredFields.forEach((field) => {
            var input = jQuery(field);
            var value = input.val();
            if ((value === "" || value === null) || (input[0].type === 'checkbox' && !input[0].checked)) {
                input.addClass("invalid")
                    .parent()
                    .find('p:not(.blacklist)')
                    .addClass("visible");//TODO css
            }
            if (input[0].checked === false) {
                input.closest('.checkbox')
                    .find('p.error')
                    .addClass('visible')
            }
        });
    },
};

//Stores all the UTM parameters
function storeUtmParameters() {
    let searchParameters = window.location.search;
    // Store UTM parameters
    if (searchParameters.includes('utm')) {
        const queryParams = new URLSearchParams(searchParameters.slice(1));
        window.sessionStorage.setItem('utmmedium', queryParams.get('utmmedium') || queryParams.get('utm_medium'));
        window.sessionStorage.setItem('utmsource', queryParams.get('utmsource') || queryParams.get('utm_source'));
        window.sessionStorage.setItem('utmcampaign', queryParams.get('utmcampaign') || queryParams.get('utm_campaign'));
        window.sessionStorage.setItem('utmcontent', queryParams.get('utmcontent') || queryParams.get('utm_content'));
        window.sessionStorage.setItem('utmkeyword', queryParams.get('utmkeyword') || queryParams.get('utm_keyword'));
    }
}

//@TODO This will be moved to marketo when we get there
function registerMarketoForms() {
    // register custom marketo form submit handlers
    var customForms = jQuery('form.custom-marketo-form, form.customized-marketo-form');
    for (var i = 0; i < customForms.length; i++) {
        jQuery(customForms[i])
            .on('submit', leadFormSubmitHandler(jQuery(customForms[i])));
    }

}

//@TODO Split out marketo and google sheets parts when we get to them.
function registerValidationHandlers() {
    /* Custom marketo form */
    jQuery('.input-field input, .textarea-field textarea, input.checkbox ')
        .on('focus', inputFieldHandlers.shiftLabelUp)
        .on('focusout', inputFieldHandlers.shiftLabelDownIfEmpty)
        .on('input', inputFieldHandlers.determineValidityState);

    /* Select field */
    jQuery('.select-field select')
        .on('input', function () {
            if (jQuery(this)
                .val() === null) {
                jQuery(this)
                    .addClass('invalid')
                    .removeClass('valid')
                    .parent()
                    .find('p')
                    .addClass("visible");
            }
            else {
                jQuery(this)
                    .addClass("selected valid")
                    .removeClass("invalid")
                    .parent()
                    .find('p')
                    .removeClass("visible");
            }
        });
    /* Select field for marketo or sheets conditional form */
    jQuery('.select-field select.conditional-sheets-marketo')
        .on('input', function () {
            if (jQuery('option:selected', this)
                .attr('name') === 'submitToSheets') {
                jQuery(this)
                    .parents('.custom-marketo-form')
                    .addClass('sheets-form')
                    .parent()
                    .find('.only-Creator input')
                    .addClass("required");
            }
            else {
                jQuery(this)
                    .parents('.custom-marketo-form')
                    .removeClass('sheets-form')
                    .parent()
                    .find('.only-Creator input')
                    .removeClass("required invalid");
            }
        });

    // Register validation handler on sheets & marketo forms
    var conditionalBehaviour = jQuery('form.conditional-behaviour');
    if (conditionalBehaviour.length > 0 && conditionalBehaviour.hasClass('conditional-behaviour')) {
        // Register conditional change effects
        jQuery('.conditional-effects', conditionalBehaviour)
            .on('change', (event) => {
                const conditionalValue = event.target.value.replaceAll(' ', '-')
                    .replaceAll('.', '-')
                const conditionId = event.target.dataset.conditionId
                // Hide conditional controls
                jQuery(`[data-condition="${conditionId}"]`, conditionalBehaviour)
                    .addClass('hidden')
                    .find('input.required')
                    .removeClass('invalid')
                    .prop('disabled', true)
                // Reset conditional controls
                jQuery(`select[data-reset-condition="${conditionId}"]`, conditionalBehaviour)
                    .prop('selectedIndex', 0)
                    .removeClass('selected valid')
                    .trigger("change")
                // Shuffle conditional select options
                jQuery(`[data-condition="${conditionId}"].only-${conditionalValue} select.hide-options`, conditionalBehaviour)
                    .each((i, select) => {
                        const optionsContainer = jQuery(`[data-for="${select.id}"]`, conditionalBehaviour)
                        // move all options to temp container
                        jQuery(`option:not(.default)`, select)
                            .detach()
                            .appendTo(optionsContainer)
                        // add conditional options to select
                        jQuery(`option[data-condition="${conditionId}"].only-${conditionalValue}`, optionsContainer)
                            .detach()
                            .appendTo(select)
                    })
                // Display conditional controls
                jQuery(`[data-condition="${conditionId}"].only-${conditionalValue}`, conditionalBehaviour)
                    .removeClass('hidden')
                    .find('input.required')
                    .addClass('required')
                    .prop('disabled', false)
            })
        // Calculate correct displays for values selected before load
        jQuery('.conditional-effects', conditionalBehaviour)
            .each((i, conditionalEffectElement) => {
                if (!conditionalEffectElement.value) {
                    return
                }
                jQuery(conditionalEffectElement)
                    .trigger('change')
            })
    }
    /* Email validation */
    jQuery('input[type="email"]')
        .on('input', function () {
            inputFieldHandlers.validateEmail(this)
        });
    jQuery("input.lazy-validate")
        .on('input', function () {
            if (this.classList.contains('invalid')) {
                inputFieldHandlers.validateEmail(this);
            }
        });

    /* Website url validation */
    jQuery(".marketo-url-field")
        .on('input', function () {
            inputFieldHandlers.validateWebsite(this)
        });

    /* Country marketing communication checkbox */
    var consent_countries = [
        'Australia',
        'Austria',
        'Belgium',
        'Bulgaria',
        'Canada',
        'China',
        'China Hong Kong',
        'Croatia',
        'Cyprus',
        'Czech Republic',
        'Denmark',
        'Estonia',
        'Finland',
        'France',
        'Germany',
        'Greece',
        'Hungary',
        'Iceland',
        'India',
        'Ireland',
        'Israel',
        'Italy',
        'Japan',
        'Latvia',
        'Lithuania',
        'Luxembourg',
        'Malta',
        'Netherlands',
        'New Zealand',
        'Poland',
        'Portugal',
        'Romania',
        'Scotland',
        'Singapore',
        'Slovakia',
        'Slovenia',
        'South Africa',
        'South Korea',
        'Spain',
        'Sweden',
        'Switzerland',
        'Taiwan',
        'United Kingdom',
        'United Arab Emirates (UAE)',
        'Vietnam',

    ];

    if (consent_countries.includes(jQuery('#Country option:selected')
        .text())) {
        jQuery("#consent")
            .addClass("open")
            .find('input')
            .removeClass("valid");
        jQuery('.select-field select')
            .addClass("selected valid")
            .removeClass("invalid")
            .parent()
            .find('p')
            .removeClass("visible");
    }
    if ((jQuery('#Country.option:selected')
        .text())) {
        jQuery('.select-field select')
            .addClass("selected valid")
            .removeClass("invalid")
            .parent()
            .find('p')
            .removeClass("visible");
    }

    jQuery('#Country, #Country__c')
        .on('input', function () {
            // TODO find full list of countries
            if (consent_countries.includes(jQuery(this)
                .val())) {
                jQuery("#consent")
                    .addClass("open")
                    .find('input')
                    .removeClass("valid");
            }
            else {
                jQuery("#consent")
                    .removeClass("open")
                    .find('input')
                    .removeClass("required")
                    .trigger('input');
            }
        });
    jQuery('.customized-marketo-form input[type="checkbox"], .custom-marketo-form input[type="checkbox"]')
        .on('input', function () {
            if (jQuery(this)
                .prop('checked')) {
                jQuery(this)
                    .addClass('valid')
            }
            else {
                jQuery(this)
                    .removeClass('valid')
            }
        });
    jQuery('input.newsletterEmail')
        .on('input', () => {
            if (jQuery('input.newsletterEmail')
                .hasClass('valid')) {
                jQuery('.newsletterEmailConsent')
                    .css('display', 'block');
            }
        });
    /* Multiple choice checkbox error & error message handling */
    jQuery('.checkbox-inner input[type=checkbox]')
        .on('input', function () {
            if (jQuery(this)
                .is(':checked')) {
                jQuery(this)
                    .closest('.checkbox')
                    .find('input[type=checkbox]')
                    .removeClass('required invalid')
                jQuery(this)
                    .closest('.checkbox')
                    .find('p.error')
                    .removeClass('visible')
            }
        });
    /* Multiple choice checkbox hidden field */
    jQuery('.checkbox-inner.show-field input[type=checkbox]')
        .on('input', function () {
            if (jQuery(this)
                .is(':checked')) {
                jQuery(this)
                    .closest('.checkbox')
                    .find('.hidden-field')
                    .addClass('visible');
            }
            else {
                jQuery(this)
                    .closest('.checkbox')
                    .find('.hidden-field')
                    .removeClass('visible');
            }
        });
}

function disableSubmitButton(form) {
    const submitButton = jQuery('button', form)
    form.classList.add('submitting');
    submitButton.attr('data-original-text', submitButton.text())
    submitButton
        .addClass('submitting')
        .attr('disabled', 'disabled')
        .html(submitButton.data('submitting-message'));
}

function enableSubmitButton(form) {
    const submitButton = jQuery('button', form)
    form.classList.remove('submitting');
    submitButton
        .removeClass('submitting')
        .removeAttr('disabled')
        .html(submitButton.data('original-text'));
}

function leadFormSubmitHandler(form) {
    return (event) => {
        event.preventDefault();
        //If form is valid continue submitting
        if (!inputFieldHandlers.isValid(form)) {
            //Add invalid classes to empty fields
            inputFieldHandlers.invalidateEmptyFields(form);
            return;
        }

        if (form.hasClass('bookit-enabled')) {
            console.log('handle bookit')
            bookItAPIRouting(form[0]);
            return;
        }
        else if (form.hasClass('sheets-form')) {
            submitSheetsForm(form, event)
        }
        else {
            submitMarketoForm(form[0])
        }
    };
}

onLoad(() => {
    var bookItForms = document.querySelectorAll('form.bookit-enabled');
    if (bookItForms.length > 0) {
        loadBookIt();
    }
    // TODO this should only load if required
    loadScript('/wp-content/themes/impact/assets/js/email-blacklist.js?v=1');
});
onReady(($) => {
    storeUtmParameters();
    registerMarketoForms();
    registerValidationHandlers();
});
